import { addResourceBundle } from '@trumpf/ux.i18n';
import JSON from '../i18n/de-DE.json';

export type TranslationKey = keyof typeof JSON.translations;

export interface TranslationFile {
  locale: string;
  translations: object;
}

export interface TranslationOptions {
  returnObjects?: boolean;
  [key: string]: string | boolean;
}

export const loadTranslations = async (locale: string): Promise<string> => {
  return await loadJSON(locale).then(translationFile => {
    addResourceBundle(translationFile.locale, 'ai-in-service', translationFile.translations);
    return translationFile.locale;
  });
};

const loadJSON = async (locale: string): Promise<TranslationFile> => {
  switch (locale.replace('_', '-').toLowerCase()) {
    case 'de-at':
    case 'de-ch':
    case 'de-de':
    case 'de':
    case 'de-int':
      return await import('../i18n/de-DE.json');
    case 'en-ca':
    case 'en-cn':
    case 'en-gb':
    case 'en-sg':
    case 'en-us':
    case 'en-int':
    case 'en':
      return await import('../i18n/en-US.json');
    default:
      return await import('../i18n/en-US.json');
  }
};

export default loadTranslations;
